import React from 'react'
import small_logo from 'assets/img/logo/logo-small.svg'
import {routes} from 'routes/routes'
import OrganizationMenu from 'organization/theme/Sidebar/OrganizationMenu'
import styled from 'styled-components'
import {LocalLink} from 'i18n/LocalLink'
import {useI18n} from 'i18n/I18nContext'

export const Menu = () => {
  const {t} = useI18n()
  return (
    <>
      <div className="logo-details">
        <span>
          <LocalLink to={routes.organization.list}>
            <img
              style={{width: '100%', height: '100%', maxHeight: '50px'}}
              className="logo__white"
              src={small_logo}
              alt={t('logo.notFound')}
            />
          </LocalLink>
        </span>
        <span>
          <LocalLink to={routes.organization.list}>
            <img
              style={{width: '180px', height: 'auto'}}
              className="log__smnall"
              src={process.env.PUBLIC_URL + '/logo-dark.svg'}
              alt={t('logo.notFound')}
            />
          </LocalLink>
        </span>
      </div>
      <div className="sidebar__inner simple-bar">
        <div className="dlabnav">
          <ul className="metismenu" id="menu">
            <OrganizationMenu />
          </ul>

          <div className="sidebar__copyright">
            <p>{t('common.allRightsReserved')} @ Atomica Group 2026</p>
            <SidebarFooterLinks>
              <li>
                <LocalLink to={routes.terms}>{t('footer.terms')}</LocalLink>
              </li>
              <li>
                <LocalLink to={routes.privacy}>{t('footer.privacy')}</LocalLink>
              </li>
              <li>
                <LocalLink to={routes.cookies}>{t('footer.cookies')}</LocalLink>
              </li>
            </SidebarFooterLinks>
          </div>
        </div>
      </div>
    </>
  )
}

export const SidebarFooterLinks = styled.ul`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  font-size: 0.9rem;

  li {
    list-style: none;
  }

  a {
    color: #666666;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`
